<template>
	<div style="background-color: #f3f3f2;" class="yrxm">
		<el-row class="bg-img">
			<img src="../../../../public/images/yrxm.jpg" style="width: 100%;height: 150px;" />
		</el-row>
		<el-row class="tac">
			<el-row :gutter="30">
				<el-col :span="6" class="menu">
					<el-card>
						<el-row style="text-align: center;">
							<h3>育人项目</h3>
						</el-row>
						<el-menu :default-active="defaultActive" router unique-opened class="el-menu-vertical-demo" collapse-transition
						 @select="handleSelect">
							<el-submenu index="1">
								<template slot="title">
									<i class="el-icon-location"></i>
									<span>2020年 第一批</span>
								</template>
								<el-menu-item-group>
									<el-menu-item index="/home/yrxm/tg2020">
										2020申报通知
									</el-menu-item>
								</el-menu-item-group>
							</el-submenu>
							<el-submenu index="2">
								<template slot="title">
									<i class="el-icon-location"></i>
									<span>2019年 第二批</span>
								</template>
								<el-menu-item-group>
									<el-menu-item index="/home/yrxm/tg2019">
										2019申报通知
									</el-menu-item>
									<el-menu-item index="/home/yrxm/gg2019">
										2019申报公告
									</el-menu-item>
								</el-menu-item-group>
							</el-submenu>
						</el-menu>
					</el-card>
				</el-col>
				<el-col :span="18" class="context">
					<el-row>
						<router-view></router-view>
					</el-row>
				</el-col>
			</el-row>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				defaultActive: '/home/yrxm/tg2020',
				isCollapse: true
			};
		},
		created() {
			this.defaultActive = this.$router.currentRoute.path
		},
		watch: {
			$route(val) {
				this.defaultActive = val.path
			}
		},
		methods: {
			handleSelect(key, keyPath) {
				// console.log(key, keyPath);
			}
		}
	}
</script>

<style scoped>
	.el-menu-vertical-demo:not(.el-menu--collapse) {
		min-width: 300px;
		min-height: 500px;
	}

	.tac {
		padding: 30px 0px;
		width: 1220px;
		margin: 0 auto;
	}

	.tac a {
		color: #666666;
	}

 
</style>
<style>
	.tac a {
		text-decoration: none;
	}
</style>
